import { MNTableContent, TableDataVersion } from '../../../../common/table/TableTypes';
import { ImMap, prop } from '../../../../common/utils/immutableHelper';

/**
 * Determines the version of the table data based on the provided table content.
 * A `version` property is expected in the `MNTableContent` object for Version 2
 */
export const getHotTableDataVersion = (
    tableContent: MNTableContent | ImMap<MNTableContent> | null | undefined,
): TableDataVersion | undefined => {
    const version = prop('version', tableContent);
    if (version) return version;

    // If there's no version property, but we have data, we assume it's Version 1
    const data = prop('data', tableContent);
    if (data) return TableDataVersion.V1;

    // There's no table content to determine the version
    return undefined;
};

/**
 * Determines if the provided table content is of version V2.
 */
export const isHotTableDataV2 = (tableContent: MNTableContent | ImMap<MNTableContent> | null | undefined): boolean => {
    const tableDataVersion = getHotTableDataVersion(tableContent);
    return tableDataVersion === TableDataVersion.V2;
};
